"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeEntity = void 0;
const class_transformer_1 = require("class-transformer");
class MeEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    username;
    role;
    /**
     * @deprecated
     */
    job;
    password;
    email;
    emailVerification;
    verified;
    /**
     * @deprecated
     */
    allowedDirect;
    /**
     * @deprecated
     */
    not_allowed_reason;
    integrations;
    isOnboardingCompleted;
    onboardingCompletedSteps;
    onboardingCompletedStepsDetails;
    isDeveloper;
    name;
    surname;
    nif;
    country;
    address;
    state;
    city;
    zip;
    birthday;
    platformUsage;
    user_info_admin;
    countryInfo;
    language;
    lang;
    phone;
    newsletter;
    fingerprints;
    referral_url_id;
    referral_user;
    /**
     * @deprecated
     */
    canRecord;
    /**
     * @deprecated
     */
    blacklist_users;
    /**
     * @deprecated
     */
    subscriptions;
    /**
     * @deprecated
     */
    following;
    /**
     * @deprecated
     */
    followers;
    /**
     * @deprecated
     */
    fav_displays;
    wallet;
    /**
     * @deprecated
     */
    comments;
    /**
     * @deprecated
     */
    notifications;
    biography;
    facebookId;
    googleId;
    /**
     * @deprecated
     */
    stripeId;
    /**
     * @deprecated
     */
    connectedStripeAccountId;
    stripe;
    sellerTransparency;
    programmaticConsents;
    /**
     * @deprecated
     */
    storeSize;
    /**
     * @deprecated
     */
    profilePrivate;
    coverUrl;
    profileImageUrl;
    themeMode;
    metadata;
    business;
    /**
     * @deprecated
     */
    retentions;
    /**
     * @deprecated
     */
    charges;
    /**
     * @deprecated
     */
    error_charges;
    /**
     * @deprecated
     */
    contributions;
    defaultDisplayFee;
    providerFees;
    /**
     * @deprecated
     */
    canSendDirect;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    last_login_at;
    createdAt;
    updatedAt;
}
exports.MeEntity = MeEntity;
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], MeEntity.prototype, "password", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Boolean)
], MeEntity.prototype, "canRecord", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "blacklist_users", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "subscriptions", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "following", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "followers", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "fav_displays", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "comments", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], MeEntity.prototype, "sellerTransparency", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], MeEntity.prototype, "programmaticConsents", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], MeEntity.prototype, "update_at", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], MeEntity.prototype, "create_at", void 0);
